/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-extraneous-dependencies,
  max-len,
  no-prototype-builtins
*/
import React from 'react';
import Dropzone from 'react-dropzone';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import Button from 'common/components/button';
import classnames from 'classnames';
import ProgressBar from 'common/components/progress-bar';
import './attachment.scss';

const messages = defineMessages({
  invalidFileType: {
    id: 'signer.attachment.invalid_file_type',
    defaultMessage: 'Invalid file type.',
    description: 'error message in signer flow, shows when signer uploads file requested by sender is not supported file type',
  },
  upload: {
    id: 'signer.attachment.upload_btn',
    defaultMessage: 'Upload',
    description: 'button text in signer flow of attachment page, signer can upload their document clicking it',
  },
});

class Attachment extends React.Component {

  isIOS = Boolean(navigator.platform.match(/(iPhone|iPod|iPad)/i));

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      uploadAttachment: false,
      showProgressBar: false,
      progressPercent: 0,
    };
  }


  onChoose = (files) => {

    if (files.length === 0) {
      this.props.setAttachmentStatus('error');
      this.setState({ error: this.props.intl.formatMessage(messages.invalidFileType), showProgressBar: false, file_uploaded_name: null });

      return;
    }

    this.props.setAttachmentStatus('uploading');
    this.setState({
      showProgressBar: true, progressPercent: 10, file_uploaded_name: null, error: null,
    });

    this.props.signatureRequest
      .on('progress', (evt) => {
        if (evt.lengthComputable) {
          const progress = (evt.loaded / evt.total) * 100;
          this.setState({
            showProgressBar: true, progressPercent: progress, error: null, file_uploaded_name: null,
          });

        }
      })
      .uploadAttachment(this.props.attachment.id, files[0])
      .then((response) => {
        if (response.success) {
          this.props.setAttachmentStatus('ready');
          this.setState({
            uploadAttachment: true, showProgressBar: false, progressPercent: 100, error: null, file_uploaded_name: files[0].name,
          });

          return;
        }

        this.props.setAttachmentStatus('error');
        this.setState({ error: response.message, showProgressBar: false, file_uploaded_name: null });

      });
  };

  isRequired() {
    return this.props.attachment.hasOwnProperty('required') && this.props.attachment.required;
  }

  triggerFileInput = (event) => {
    // on an iOS device, the upload button requires multiple/double clicks to trigger
    // the native browser file picker to open, this hack forces the picker to open
    // on a single click, and also this check is to ensure the file picker isn't
    // opened a second time on desktop browsers. (handles touch screen devices)
    // FIX ME: come up with a better solution to trigger the file picker
    if (this.isIOS) {
      event.preventDefault();
      this.dropZoneRef.open();
    }
  };

  render() {
    const instructions = this.props.attachment.hasOwnProperty('instructions') && this.props.attachment.instructions !== null ? (
      <div className="attachment-container__instructions-container">
        <p className="attachment-container__instructions">
          <span className="attachment-container__instructions__title">
            <FormattedMessage
              id="signer.attachment.instructions"
              description="text in signer flow of attachment page, shows the instruction posted by sender"
              defaultMessage="Instructions" />
          </span>
          {` ${this.props.attachment.instructions}`}
        </p>
      </div>
    ) : '';

    const error = this.state.error !== null ? (
      <div className="attachment-container__info attachment-container__info-border">
        <p className="attachment-container__info-text">{ this.state.error }</p>
      </div>
    ) : '';

    const fileSuccess = this.state.file_uploaded_name ? (
      <div className="attachment-container__info attachment-container__info-border" data-qa-ref="upload-success">
        <p className="attachment-container__info-text">
          <FormattedMessage
            id=""
            description="text in signer flow of attachment page, shows the name of uploaded file"
            defaultMessage="Uploaded File: { file_uploaded_name }"
            values={{
              file_uploaded_name: this.state.file_uploaded_name,
            }} />
        </p>
      </div>
    ) : '';

    const attachmentClassName = classnames('attachment-container', {
      'attachment-container--error': this.state.error,
      'attachment-container--success': this.state.file_uploaded_name,
    });

    const requiredField = this.isRequired() ? (
      <span className="attachment-container__required" >*</span>
    ) : '';

    const progressBar = this.state.showProgressBar ? (
      <div className="attachment-container__info attachment-container__info-progress">
        <ProgressBar progressPercent={this.state.progressPercent} />
      </div>
    ) : '';
    return (
      <div className={attachmentClassName}>
        <div className="attachment-container__header">
          <h6 className="attachment-container__title">{this.props.attachment.name} {requiredField}</h6>
          <div className="attachment-container__header__upload-btn">
            <Dropzone multiple={false}
              ref={(dz) => { this.dropZoneRef = dz; }}
              accept=".jpeg,.png,.jpg,.gif,.tiff,.pdf"
              onDrop={this.onChoose}
            >
              {({ getRootProps, getInputProps }) => (
                <div
                  {...getRootProps()}
                  style={{ float: 'right', display: 'inline', outline: 'none' }}
                >
                  <input {...getInputProps()} />
                  <Button
                    buttonColor={this.state.uploadAttachment ? 'white' : 'cerulean'}
                    buttonBorderColor="cerulean"
                    buttonTextColor={this.state.uploadAttachment ? 'cerulean' : 'white'}
                    buttonTextHoverColor={this.state.uploadAttachment ? 'white' : 'cerulean'}
                    buttonHoverColor="cerulean"
                    onClick={this.triggerFileInput}
                    buttonText={this.props.intl.formatMessage(messages.upload)}
                    data-qa-ref="upload-btn" />
                </div>
              )}
            </Dropzone>
          </div>
        </div>
        {instructions}
        <div className="attachment-container__info-container">
          <p className="attachment-container__info-text">
            <FormattedMessage
              id="signer.attachment.accepted_file_formats"
              description="text in signer flow of attachment page, tells signer the format and size of the file to upload"
              defaultMessage="Acceptable file formats: .png, .pdf, .gif, .tiff * Max File Size: 3MB." />
          </p>
        </div>
        {error}
        {progressBar}
        {fileSuccess}
      </div>
    );
  }

}

export default Attachment;
export const AttachmentWithIntl = injectIntl(Attachment);
AttachmentWithIntl.displayName = 'Attachment';
